import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";
import styled, { useTheme } from "styled-components";
import { useApi } from "../../contexts/ApiContext";
import { fontSizes } from "../../theme";

const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "white",
  border: "1px solid #E7E5E4",
}));

interface ToggleInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
}

const ToggleInput: React.FC<ToggleInputProps> = ({
  onChange,
  value,
  label,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  const theme = useTheme();
  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <StyledBox>
      <FormControlLabel
        control={
          <Checkbox
            disabled={isDisabled}
            sx={{ paddingLeft: theme.spacing(3), paddingY: 0.8 }}
            checked={!!value}
            onChange={handleChange}
          />
        }
        label={label}
        componentsProps={{
          typography: {
            fontSize: fontSizes.sm,
            fontWeight: "normal",
          },
        }}
      />
    </StyledBox>
  );
};

export default ToggleInput;
